import { environment } from "apps/ciptech/src/environments/environment";


export class FileUtil {
	constructor() { }

	static obtenerExtension(nombre: string): string {
		const pos = nombre.lastIndexOf('.');
		return pos >= 0
			? nombre.substring(pos + 1).toLowerCase()
			: '';
	}

	static obtenerIconoArchivo(extension?: string): string {
		switch (this.obtenerExtension(extension || '')) {
			case 'pdf':
				return 'fa-file-pdf-o';

			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'bmp':
			case 'webp':
				return 'fa-file-image-o';

			case 'doc':
			case 'docx':
				return 'fa-file-word-o';

			case 'xls':
			case 'xlsx':
				return 'fa-file-excel-o';

			case 'zip':
			case 'rar':
			case '7z':
				return 'fa-file-archive-o';

			default:
				return 'fa-file-o';
		}
	}

	static obtenerPesoAsString(peso?: number): string {
		if (!peso)
			return '0 KB';

		const kb = peso / 1024;
		if (kb < 1024)
			return `${kb.toFixed(1)} KB`;
		return `${(kb / 1024).toFixed(2)} MB`;
	}

	static esPdf(extension?: string): boolean {
		return this.obtenerExtension(extension || '') === 'pdf';
	}

	static esImagen(extension?: string): boolean {
		return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(this.obtenerExtension(extension || ''));
	}

	static PesoMaximoPermitido(): number {
		const peso = environment.FILE_VAR.MAX_PESO;
		return ((peso.GB || 0) * 1024 * 1024 * 1024) +
			((peso.MB || 0) * 1024 * 1024) +
			((peso.KB || 0) * 1024);
	}

	static PesoMaximoTexto(): string {
		const peso = environment.FILE_VAR.MAX_PESO;
		if (peso.GB > 0) {
			return `${peso.GB} GB`;
		}
		if (peso.MB > 0) {
			return `${peso.MB} MB`;
		}
		if (peso.KB > 0) {
			return `${peso.KB} KB`;
		}
		return 'Sin límite';
	}
}